module.exports = __webpack_public_path__ + "assets/img/body_bg.9baa175f.jpg";